'use client';

import React from 'react';

export const useOnce = (callback: () => void, onReset: () => void = () => undefined) => {
  const ref = React.useRef<boolean>(true);
  return [
    () => {
      if (ref.current) {
        ref.current = false;
        callback();
      }
    },
    () => {
      ref.current = true;
      onReset();
    },
  ];
};
